import ContentCard from './ContentCard'
import style from './style.module.scss'
import { Props } from './types'
import { Header } from '@crossfit/design-system'

function CuratedContentList({ headlineText, contentItems }: Props) {
  return (
    <div className={style.wrapper}>
      <Header size={'md'} as={'h2'} className={style.header} color='black'>
        {headlineText}
      </Header>
      <div className={style.cardContainer}>
        {contentItems?.map((item) => (
          <ContentCard item={item} key={item.headlineText} />
        ))}
      </div>
    </div>
  )
}

export default CuratedContentList
